/**
 * L'application du magasinier — l'enveloppe, en attendant ses écrans.
 *
 * *Demande de Chris, 07/09/2026 : le magasinier « aura accès uniquement à ce module ».*
 *
 * ## Pourquoi une enveloppe SÉPARÉE, et pas l'application avec des boutons en moins
 *
 * L'application charge au démarrage les chantiers, les ressources génériques, les regroupements
 * et les carrières — tout ce que le rôle `magasin` n'a pas le droit de lire (067). Un compte
 * magasin qui l'ouvrirait ne verrait donc pas « moins de boutons » : il verrait une **page en
 * erreur**, quatre refus d'accès avant même d'avoir cliqué.
 *
 * Masquer des boutons n'aurait rien réglé non plus, puisque ces appels partent au montage et non
 * au clic. Le rôle décide donc de l'enveloppe, pas du contenu d'un menu — ce qui a l'avantage
 * d'être vrai : ce n'est pas la même application.
 *
 * ## Le même écran que dans l'application complète
 *
 * `Stocks` est servi ici et sous le bouton « Stocks » du menu (Chris, 07/09/2026 : « à côté de
 * contre-étude »). Un seul chemin de saisie, donc une seule chose à apprendre pour le magasinier, un seul
 * endroit où un défaut peut se cacher, et la certitude que ce que Chris voit à son bureau est
 * exactement ce que le magasinier a sous les yeux dans le rayonnage.
 */
import type { JSX } from "react";
import type { Compte } from "./api";
import { Stocks } from "./Stocks";

export function Magasin({
  moi,
  onDeconnexion,
}: {
  readonly moi: Compte;
  readonly onDeconnexion: () => void;
}): JSX.Element {
  return (
    <main className="magasin">
      <header className="magasin__entete">
        <h1>Stocks</h1>
        <p className="magasin__compte">
          {moi.prenom} {moi.nom}
          <button type="button" className="lien" onClick={onDeconnexion}>
            Se déconnecter
          </button>
        </p>
      </header>

      <Stocks />
    </main>
  );
}
